var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUstc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#183EA4",
    d: "M8.001 8.04a3.52 3.52 0 0 0 1.492 1.688c.95.588 4.864-1.637 6.702-2.82c-.381-.445-1.697-1.337-3.921-1.337c-2.229 0-3.579 1.089-3.977 1.637l-.3.832zm6.476 9.93c-.227.103-.793.356-1.059.343c-.317-.009-1.328-.54-1.907-1.547c-.583-1.008-.591-1.672-.12-2.272c.45-.5.959-.946 1.513-1.328l4.971.844c.052.283-.115 1.114-1.187 2.228c-1.071 1.102-1.855 1.586-2.117 1.689z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedUstc0)",
    d: "M10.045 7.041c-.857 1.303-3.72 2.22-4.191 2.079l-.004-.01q.261-.54.617-1.024a6.9 6.9 0 0 1 2.031-1.86c.289-.162.612-.25.943-.257c1.277.026.613 1.058.604 1.071"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedUstc1)",
    d: "M9.343 16.247c.06.411 0 2.027-.086 2.164c-.073.005-.219.013-.652-.231a6.86 6.86 0 0 1-2.7-2.829a6.9 6.9 0 0 1-.672-4.303q.105-.65.33-1.268c.497.664 1.07 1.264 1.555 1.928q.651.93 1.23 1.903c.806 1.38.935 2.229.995 2.636"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedUstc2)",
    d: "M18.857 12.171c0 .9-.172 1.757-.476 2.542c-.81.874-6.257-1.282-6.308-1.303c-.746-.33-3.013-1.329-3.215-2.906c-.295-2.263 4.256-3.84 6.257-3.9c.24.004.973.013 1.397.36a6.92 6.92 0 0 1 2.345 5.207"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedUstc3)",
    d: "M15.171 18.304c-.596.279-1.247.077-1.08-.506c.33-1.118 3.172-2.271 3.801-2.331c.082-.004.112.047.078.107a6.95 6.95 0 0 1-2.799 2.73"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedUstc0",
    x1: 7.18,
    x2: 19.411,
    y1: 16.715,
    y2: 13.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58C07B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5599E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedUstc1",
    x1: 3.179,
    x2: 16.186,
    y1: 9.567,
    y2: 6.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#57BC87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#5493F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedUstc2",
    x1: 5.421,
    x2: 19.581,
    y1: 11.997,
    y2: 11.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58C56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5492F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedUstc3",
    x1: 14.254,
    x2: 18.115,
    y1: 17.396,
    y2: 15.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58C178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5493F0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUstc);
export default __webpack_public_path__ + "static/media/ustc.c7bc9e03e556dabc93d02ffc67cc5b5b.svg";
export { ForwardRef as ReactComponent };